import { ActiveAuthForm } from './enum/active-auth-form';
import { RegisterRole } from './enum/register-role';
import { User } from './type/user';
import parseISO from 'date-fns/parseISO';

export function getActiveAuthFormSelector(state: any): ActiveAuthForm {
  return state.auth.activeAuthForm;
}

export function getResendTimerSelector(state: any): Date | undefined {
  return state.auth.resendTimer ? parseISO(state.auth.resendTimer) : undefined;
}

export function getRegisterPhoneSelector(state: any): string | undefined {
  return state.auth.registerPhone;
}

export function getCurrentUserSelector(state: any): User | undefined {
  return state.auth.user;
}

export function getRegisterRoleSelector(state: any): RegisterRole {
  return state.auth.registerRole;
}
